export default{ "true": "Publicado", "false": "Rascunho" }